import { render } from "./jin-qlc.vue?vue&type=template&id=08e49bf6&scoped=true"
import script from "./jin-qlc.vue?vue&type=script&lang=js"
export * from "./jin-qlc.vue?vue&type=script&lang=js"

import "./jin-qlc.vue?vue&type=style&index=0&id=08e49bf6&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08e49bf6"]])

export default __exports__